import type { PublicApiKey } from '#packages/apilib';
import type { createThemeApi } from './themeWrapper';

export const ThemeApiKey: PublicApiKey<typeof createThemeApi> = {
  name: 'ThemeApi',
  public: true,
};
